import { render, staticRenderFns } from "./EvaluatorTestScore.vue?vue&type=template&id=2f15c72f&scoped=true"
import script from "./EvaluatorTestScore.vue?vue&type=script&lang=js"
export * from "./EvaluatorTestScore.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=2f15c72f&prod&scoped=true&lang=css&external"
import style1 from "./EvaluatorTestScore.vue?vue&type=style&index=1&id=2f15c72f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15c72f",
  null
  
)

export default component.exports